module.exports = __webpack_public_path__ + "img/orangevert.b9d1f807.png";